import { Modal } from 'bootstrap';
import * as htmx from "htmx.org";
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('formCheckout');

    if (form) {
        const branchLabel = document.querySelectorAll('.js--branch_label');
        const submitBtn = document.querySelector('.js--checkout_submit');
        const checkboxContainer = document.getElementById('prepay');
        const selectedItemsList = document.querySelector('.js--selected-items-list');
        const summaryAdditionalBtn = document.querySelector('.js--summary_additional_btn');
        const personInput = document.querySelector('.js--kit-checkout-person-input');
        let lastSelectedCheckbox = [];
        const radios = Array.from(document.querySelectorAll('input[name="kit"]'));
        if (!radios.find(radio => radio.checked)) {
            submitBtn.disabled = true;
        }

        if (document.querySelector('.checkout__additional')) {
            document.querySelector('.checkout__summary_additional').style.display = 'block';
        } else {
            document.querySelector('.checkout__summary_additional').style.display = 'none';
        }


        function updateSummaryKit() {
            const selectedRadio = document.querySelector('input[name="kit"]:checked');
            if (selectedRadio) {
                const selectedLabel = selectedRadio.nextElementSibling;
                const clonedLabel = selectedLabel.cloneNode(true);

                const summaryKit = document.querySelector('.js--summary_selected_kit');
                if (summaryKit) {
                    summaryKit.innerHTML = '';
                    summaryKit.style.setProperty('--branch-label-color', clonedLabel.getAttribute('data-color'));
                    summaryKit.appendChild(clonedLabel);
                }
                submitBtn.disabled = false;
            }
        }
        function updateSummaryPrice() {
            const selectedRadioPeriod = document.querySelector('input[name="period"]:checked');
            if (selectedRadioPeriod) {
                const selectedPeriodPrice = selectedRadioPeriod.nextElementSibling.querySelector('.prepay_radio_label_price');
                const selectedPeriod = selectedRadioPeriod.nextElementSibling.querySelector('.prepay_radio_label_period');

                const summaryKitPrice = document.querySelector('.js--summary_kit_price');
                const summaryKitPeriod = document.querySelector('.js--summary_kit_period');
                if (summaryKitPrice && summaryKitPeriod) {
                    summaryKitPrice.innerHTML = selectedPeriodPrice.innerHTML;
                    summaryKitPeriod.innerHTML = selectedPeriod.innerHTML.replace('/', '').trim();
                }
            }
        }
        const stateData = state();
        const kit = stateData.get('kit');
        if (kit) {
            updateSummaryKit();
            updateSummaryPrice();
            document.querySelector('.checkout__summary_kit').style.display = 'flex';
        } else {
            document.querySelector('.checkout__summary_kit').style.display = 'none';
        }

        const wrapersSteps = {
            user: 'kits',
            kits: 'prices',
            prices: 'products',
            products: 'summary',
        };

        updateWrapper();
        renderSelectedItems();

        if (branchLabel) {
            branchLabel.forEach(item => {
                item.style.setProperty('--branch-label-color', item.getAttribute('data-color'));
            });
        }

        if (summaryAdditionalBtn) {
            summaryAdditionalBtn.addEventListener('click', () => {
                highlightWrapper('products');
            });
        }

        document.addEventListener('click', (event) => {
            if (event.target.closest('.js--additional_skip')) {
                if (window.innerWidth < 1280) {
                    highlightWrapper('summary');
                } else {
                    highlightWrapper('summary', false);
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
            }
        });

        // Change person

        personInput.addEventListener('change', function (event) {
            const companyField = document.getElementById('companyField');
            const inputCompanyField = companyField.querySelector('input');
            const paymentCashless = document.getElementById('paymentCard');
            const paymentInvoice = document.getElementById('paymentInvoice');

            if (event.target.checked) {
                companyField.style.display = 'none';
                inputCompanyField.classList.add('hidden');
                inputCompanyField.classList.remove('validate');
                paymentCashless.style.display = 'flex';
                setTimeout( () => {
                    window.customForms[form.getAttribute('id')].mutators.registerField();
                }, 150);
            } else {
                paymentCashless.style.display = 'none';
                companyField.style.display = 'block';
                inputCompanyField.classList.remove('hidden');
                inputCompanyField.classList.add('validate');
                if (getComputedStyle(paymentCashless).display === 'none') {
                    paymentInvoice.click();
                    inputCompanyField.value = '';
                }
                setTimeout( () => {
                    window.customForms[form.getAttribute('id')].mutators.registerField();
                }, 150);
            }

            updateState();
            updateSummary();
        });


        // Before change

        document.body.addEventListener('htmx:beforeSwap', function (evt) {

            if (evt.detail.target.id === 'additional') {
                const oldCheckboxes = checkboxContainer.querySelectorAll('.js--kit-checkout-product-input:checked');
                oldCheckboxes.forEach(item => {
                    lastSelectedCheckbox.push(item.value);
                });
            }
        });
let isShowConfirmModal = true;

        // Change kit

        document.addEventListener("change", function (event) {
            let element = event.target;
            const stateData = state();
            const kit = stateData.get('kit');


            if (element.classList.contains("js--kit-checkout-kit-input") && kit && isShowConfirmModal) {
                const confirmModalChangeKit = new Modal(document.getElementById('confirmModalChangeKit'));
                event.stopImmediatePropagation();
                event.preventDefault();
                confirmModalChangeKit.show();

                const confirmChangeKitBtn = document.querySelector('.js--confirm-change-kit');
                const cancelChangeKitBtn = document.querySelector('.js--cancel-change-kit');

                cancelChangeKitBtn.onclick = function () {
                    let previousChecked = document.querySelector('.js--kit-checkout-kit-input[data-previous="true"]');
                    if (previousChecked) {
                        previousChecked.checked = true;
                    }
                    confirmModalChangeKit.hide();
                };

                confirmChangeKitBtn.onclick = function () {
                    document.querySelectorAll('.js--kit-checkout-kit-input').forEach(input => {
                        input.dataset.previous = "false";
                    });
                    element.dataset.previous = "true";

                    isShowConfirmModal = false;

                    htmx.trigger(element, "change");

                    confirmModalChangeKit.hide();
                };
                confirmModalChangeKit._element.addEventListener('hidden.bs.modal', function () {
                    let previousChecked = document.querySelector('.js--kit-checkout-kit-input[data-previous="true"]');
                    if (previousChecked) {
                        previousChecked.checked = true;
                    }
                });
            }
        }, true);


        document.body.addEventListener('htmx:afterSettle', function (evt) {
            if (evt.detail.target.id === 'prepay') {
                const radioButton = document.querySelector('input[type="radio"][data-value="month_12"]');
                    if (radioButton) {
                        radioButton.click();
                        highlightWrapper('prices');
                        cleanSummaryProducts();
                        updateState();
                        updateSummary();
                        updateSummaryPrice();
                        document.querySelector('.checkout__summary_kit').style.display = 'flex';
                    }

            }
            if (evt.detail.target.id === 'additional') {
                cleanSummaryProducts();
                render();
                updateState();
                updateSummary();
                const newCheckboxes = checkboxContainer.querySelectorAll('.js--kit-checkout-product-input');
                newCheckboxes.forEach((checkbox) => {
                    if (lastSelectedCheckbox.includes(checkbox.value)) {
                        checkbox.click();
                    }
                });
                lastSelectedCheckbox = [];
            }

            updateSummaryKit();
            updateSummaryPrice();
            if (document.querySelector('.checkout__additional')) {
                document.querySelector('.checkout__summary_additional').style.display = 'block';
            } else {
                document.querySelector('.checkout__summary_additional').style.display = 'none';
            }
            isShowConfirmModal = true;
        });



        // Change price (period)

        document.addEventListener('change', (event) => {
            if (event.target.closest('.js--kit-checkout-price-input')) {
                highlightWrapper('products');
                cleanSummaryProducts();
                render();
                updateState();
                updateSummary();
                updateSummaryPrice();
            }
        });

        // Change product

        document.addEventListener('change', (event) => {
            if (event.target.closest('.js--kit-checkout-product-input')) {
                renderSelectedItems.call(event.target, event);
                highlightWrapper('summary', false);
                render();
                updateState();
                updateSummary();
            }
        });
        // Change payment

        document.addEventListener('change', (event) => {
            if (event.target.closest('.js--kit-checkout-payment-input')) {
                updateState();
                render();
            }
        });

        function highlightWrapper(wrapper, scrolling = true) {
            const wrappers = document.querySelectorAll('.js--wrapper');
            let wrapperElement = document.querySelector(`.js--wrapper[data-wrapper="${wrapper}"]`);

            if (wrapper === 'products' && !wrapperElement) {
                const nextWrapper = getNextWrapper(wrapper);
                wrapperElement = document.querySelector(`.js--wrapper[data-wrapper="${nextWrapper}"]`);
            }

            if (wrapperElement) {
                wrappers.forEach(wrap => wrap.classList.remove('focused'));

                if (scrolling) {
                    setTimeout(() => {
                        const isSticky = window.getComputedStyle(wrapperElement).position === 'sticky';
                        const stickyHeight = isSticky ? wrapperElement.offsetHeight : 0;
                        const elementPosition = wrapperElement.getBoundingClientRect().top + window.pageYOffset;
                        const offsetPosition = elementPosition - stickyHeight - 200;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }, 300);
                }

                wrapperElement.classList.add('focused');
            }
        }

        function getNextWrapper(currentWrapper) {
            if (wrapersSteps.hasOwnProperty(currentWrapper)) {
                return wrapersSteps[currentWrapper];
            }

            return false;
        }

        function state() {
            return new URLSearchParams(window.location.search);
        }

        function updateWrapper() {
            const stateData = state();
            const kit = stateData.get('kit');
            const period = stateData.get('period');
            const product = stateData.get('product');
            const productWrapper = document.querySelector('.js--wrapper[data-wrapper="products"]');
            if (kit && period && product) {
                highlightWrapper('summary', false);
            }
            if (kit && period) {
                highlightWrapper('summary', false);
            }
            if (kit && !period) {
                highlightWrapper('prices', false);
            }
            if (kit && period && productWrapper && !product) {
                highlightWrapper('products', false);
            }
            if (!kit) {
                highlightWrapper('kits', false);
            }
        }

        function updateState() {
            const stateData = state();


            const checkboxesAndRadios = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
            let selectedCheckbox = [];

            checkboxesAndRadios.forEach(element => {
                if (element.type === 'radio' && element.checked) {
                    if (element.name === 'kit') {
                        stateData.delete('period');
                        stateData.delete('product');
                        stateData.set(element.name, element.dataset.value);
                    } else if (element.name === 'period') {
                        stateData.delete('product');
                        stateData.set(element.name, element.dataset.value);
                    } else if (element.name === 'payment') {
                        stateData.set(element.name, element.dataset.value);
                    }
                }

                if (element.type === 'checkbox') {
                    if (element.name === 'product' && element.checked) {
                        selectedCheckbox.push(element.value);
                        stateData.set(element.name, selectedCheckbox.join(','));
                    } else if (element.name === 'person') {
                        if (element.checked) {
                            stateData.set(element.name, element.value);
                        } else {
                            stateData.set(element.name, 'ur');
                        }
                    }
                }

            });
            window.history.replaceState({}, '', `${window.location.pathname}?${stateData}`);
        }

        function render() {
            const stateData = state();
            const payment = stateData.get('payment');
            const period = stateData.get('period');
            if (!period) {
                const radioButton = document.querySelector('input[type="radio"][data-value="month_12"]');
                if (radioButton) {
                    radioButton.click();
                }
            }

            if (payment === 'cashless') {
                submitBtn.querySelector('.js--button_text').textContent = submitBtn.getAttribute('data-cashless-text');
            } else {
                submitBtn.querySelector('.js--button_text').textContent = submitBtn.getAttribute('data-card-text');
            }

            if (selectedItemsList) {
                const items = selectedItemsList.querySelectorAll('li');

                if (items.length > 0) {
                    document.querySelector('.checkout__summary_additional_none').classList.add('hide');
                } else {
                    document.querySelector('.checkout__summary_additional_none').classList.remove('hide');
                }
            }
        }

        function updateSummary() {
            let stateData = state();
            let postData = {};

            if (stateData.has('kit')) {
                postData.kit = stateData.get('kit');
            }

            if (stateData.has('period')) {
                postData.period = stateData.get('period');
            }

            if (stateData.has('product')) {
                postData.product = decodeURIComponent(stateData.get('product'));
            }

            fetch('/checkout-ajax/summary', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    document.querySelector('.js--price_set').textContent = `${data.set}.00`;
                    document.querySelector('.js--price_additional').textContent = `${data.additional}.00`;
                    document.querySelector('.js--price_discount').textContent = `${data.discount}.00`;
                    document.querySelector('.js--price_summary').textContent = `${data.summary}.00`;
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }

        function cleanSummaryProducts() {
            if (selectedItemsList) {
                selectedItemsList.innerHTML = '';
            }
        }

        function renderSelectedItems() {
            cleanSummaryProducts();

            if (checkboxContainer) {
                const checkboxes = checkboxContainer.querySelectorAll('.js--kit-checkout-product-input:checked');

                checkboxes.forEach(checkbox => {
                    const label = checkbox.nextElementSibling.querySelector('.additional_checkbox_label_text').innerText;
                    const li = document.createElement('li');
                    const span = document.createElement('span');
                    span.textContent = `${label}`;
                    li.appendChild(span);

                    const removeBtn = document.createElement('input');
                    removeBtn.className = 'remove-btn';
                    removeBtn.type = 'button';

                    removeBtn.addEventListener('click', function () {
                        const confirmModal = new Modal(document.getElementById('confirmModal'));
                        confirmModal.show();

                        const confirmDeleteBtn = document.querySelector('.js--confirm-delete');
                        confirmDeleteBtn.onclick = function () {
                            checkbox.checked = false;
                            renderSelectedItems();
                            updateState();
                            updateSummary();
                            confirmModal.hide();
                        };
                    });

                    li.appendChild(removeBtn);

                    selectedItemsList.appendChild(li);
                });
            }

            render();
            updateState();
        }

        const stickyWrapper = document.querySelector('.checkout__summary.js--wrapper');
        const accordionButton = document.querySelector('.js--accordion_product_button');
        const accordionCollapse = document.querySelector('.js--accordion_product_collapse');
        const sentinel = document.createElement('div');

        if (stickyWrapper) {
            sentinel.style.position = 'absolute';
            sentinel.style.top = `${stickyWrapper.offsetTop - 1}px`;
            document.body.prepend(sentinel);
        }

        function collapseAccordion() {
            if (accordionCollapse && accordionCollapse.classList.contains('show')) {
                accordionButton.click();
            }
        }

        const collapseObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        collapseAccordion();
                        collapseObserver.disconnect();
                    }
                });
            },
            {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0,
            }
        );

        collapseObserver.observe(sentinel);
    }
});
